"use client";

import { Button } from "@mantine/core";
import { useTranslations } from "next-intl";

type SubscriptionConfirmationProps = {
  handleSubscription: (acceptOffer: boolean) => void;
  close: () => void;
  isLoading: boolean;
};

export function SubscriptionConfirmation({
  handleSubscription,
  close,
  isLoading,
}: SubscriptionConfirmationProps) {
  const t = useTranslations("subscription");

  return (
    <div className="grid grid-cols-1 gap-y-6 lg:w-[447px]">
      <h2 className="text-xl font-semibold">{t("confirm-cancel.title")}</h2>
      <p className="text-base leading-6 text-text-secondary">
        {t("confirm-cancel.description")}
      </p>
      <div className="flex w-full flex-col-reverse items-center gap-4 pb-6 sm:flex-row sm:justify-between">
        <Button
          className="flex-1"
          variant="filled"
          color="dark"
          radius="xl"
          size="md"
          onClick={() => handleSubscription(false)}
          disabled={isLoading}
          loading={isLoading}
        >
          {t("confirm-cancel.yes")}
        </Button>
        <Button
          className="flex-1"
          variant="filled"
          radius="xl"
          size="md"
          onClick={close}
        >
          {t("confirm-cancel.no")}
        </Button>
      </div>
    </div>
  );
}
